import {
    Menu,
    MenuItem
} from '@mui/material';
import { Menu as MenuIcon } from '@tassat/icon';
import React, { useState } from 'react';

import { muiStyles } from './style';

type BaseOption = {
    title: string;
    id: string;
};

interface PledgeActionMenuProps<T extends BaseOption> {
    options: T[];
    onSelect: (option: T) => void;
}

export const PledgeActionMenu = <T extends BaseOption>(props: PledgeActionMenuProps<T>) => {
    const {
        options,
        onSelect
    } = props;

    const [ menuAnchor, setMenuAnchor ] = useState<HTMLButtonElement | null>(null);
    const handleMenuClose = () => setMenuAnchor(null);
    const classes = muiStyles(props);

    return (
        <>
            <button
                className={classes.actionsButton}
                onClick={(e) => setMenuAnchor(e.currentTarget)}
            >
                ACTIONS
                <MenuIcon
                    className={classes.menuIcon}
                    iconColor='#FFF'
                />
            </button>
            <Menu
                anchorEl={menuAnchor}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left'
                }}
                id='sort-menu'
                keepMounted
                onClose={handleMenuClose}
                open={Boolean(menuAnchor)}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left'
                }}
            >
                {options.map((option, key) => (
                    <MenuItem
                        className={`${classes.dropdownItem} ${key === 0 && classes.firstDropdownItem} ${key === (options.length - 1) && classes.lastDropdownItem}`}
                        id={option.id}
                        key={option.id}
                        onClick={() => {
                            onSelect(option);
                            handleMenuClose();
                        }}
                    >
                        {option.title}
                    </MenuItem>
                ))}
            </Menu>
        </>
    );
};